<template>
  <div class="container">
    <div class="grid grid-cols-4 gap-2">
      <slot name="filter" />
    </div>

    <div class="grid">
      <t-table
        ref="table"
        v-bind="$attrs"
        v-on="$listeners"
        :data="data"
        :headers="localHeaders"
      >
        <template v-for="(idx, slot) in $scopedSlots" v-slot:[slot]="data">
          <slot :name="slot" v-bind="data"></slot>
        </template>

        <template v-slot:row="props">
          <tr
            class="hover:bg-gray-100"
            :class="[props.trClass, props.row.deleted ? 'text-red-800' : '', props.rowIndex % 2 === 0 ? 'bg-gray-50' : '']">
            <slot name="row" v-bind="props"></slot>
            <td :class="props.tdClass">
              <div>
                <button class="mx-1 action-button text-red-800 hover:text-red-500" type="button" @click="$emit('delete', props.row)"><i class="fa fas fa-trash"></i></button>
                <!-- <a class="mx-1 action-button text-green-500 hover:text-green-800" type="button" @click="$emit('restore', props.row)"><i class="fa fas fa-trash-restore"></i></a> -->
                <button class="mx-1 action-button text-coolGray-800 hover:text-coolGray-500" type="button" @click="$emit('edit', props.row)"><i class="fa fas fa-edit"></i></button>
                <button v-for="action in actions" v-bind:key="action.name"
                   class="mx-1 action-button text-coolGray-800 hover:text-coolGray-500" :class="action.classes" type="button" @click="$emit(action.event, props.row)"><i :class="action.icon"></i></button>
              </div>
            </td>
          </tr>
        </template>
      </t-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    headers: {
      type: Array,
      requried: true,
    },

    data: {
      type: Array,
      required: true,
    },

    index: {
      type: Boolean,
      default: false,
    },

    actions: {
      type: Array,
      required: false,
      default: undefined,
    },
  },

  mounted() {
    // this.fetchData();
  },

  watch: {
    hSelected(value) {
      this.$emit("input", this.hSelected);
    },
  },

  data() {
    return {
      fetchedItems: [],
      loading: false,
    };
  },

  computed: {
    localHeaders() {
      let headers = this.headers.slice();

      if (this.index) {
        headers.splice(0, 0, "#");
      }

      if (this.actions) {
        headers.push("Azioni");
      }

      return headers;
    },
  },

  methods: {
    async fetchData() {
      this.loading = true;
      var response = await this.data();
      this.fetchedItems = response.data.data;
      this.loading = false;
    },
  },
};
</script>
<style lang="css" scoped>
.action-button {
    opacity: 0;
}

tr:hover .action-button {
    opacity: 1;
}
</style>
